// extracted by mini-css-extract-plugin
export default {"card":"r2-z","carouselContainer":"s2-z","carouselContent":"t2-z"};